import Vue from 'vue'
import VueRouter from 'vue-router'
import Homepage from '../views/pannels/HomePage.vue'
import Chatpage from '../views/pannels/ChatPage.vue'
import KnowledgeBase from '../views/pannels/KnowledgeBase.vue'
import KbFolderPage from '../views/pannels/KbFolderPage.vue'
import BIMPlanet from '../views/pannels/BIMPlanet.vue'
import UserBalance from '../views/pannels/UserBalance.vue'

Vue.use(VueRouter)

const routes = [
  {
    path:'/',
    redirect: '/homepage' // 重定向到 /homepage
  },
  {
    // 重定向到主页
    path: '/',
    name: 'homepage',
    component: Homepage
  },
  {
    path: '/homepage',
    name: 'homepage',
    component: Homepage
  },
  {
    path: '/chat',
    name: 'chat',
    component: Chatpage
  },
  {
    path: '/knowledgebase',
    name: 'knowledgebase',
    component: KnowledgeBase
  },
  {
    path: '/knowledgebase/:folderName',
    name: 'KbFolderPage',
    component: KbFolderPage
  },
  {
    path: '/bimplanet',
    name: 'BIMPlanet',
    component: BIMPlanet
  },
  {
    path: '/balance',
    name: 'UserBalance',
    component: UserBalance
  },
  {
    path: '/productintro',
    name: 'ProductIntro',
    component: () => import('../views/pannels/ProductIntro.vue')
  },
  {
    path: '/contact',
    name: 'ContactPage',
    component: () => import('../views/pannels/ContactPage.vue')
  },
  {
    path: '/user-agreement',
    name: 'UserAgreement',
    component: () => import('../views/pannels/UserAgreement.vue')
  }
]


const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
router.beforeEach((to, from, next) => {
  if (to.path === from.path|| (to.name === from.name )) {
     next(false);// 取消导航
  } else {
    next(); // 继续导航
  }


});

export default router
